import i18next from 'i18next';

export function hasTextVariableInLanguageFile(textId: string): boolean {
    return i18next.t(textId).includes('{{');
}
